import React, { useEffect, useState } from 'react';
import axios from 'axios';

const SignatureImage = ({ src, alt, style }) => {
  const [imageUrl, setImageUrl] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let isActive = true;
    let objectUrl = '';

    const loadImage = async () => {
      if (!src) return;
      setFailed(false);
      try {
        const token = localStorage.getItem('auth_token');
        const response = await axios.get(src, {
          responseType: 'blob',
          withCredentials: true,
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        if (!isActive) return;
        objectUrl = URL.createObjectURL(response.data);
        setImageUrl(objectUrl);
      } catch (error) {
        if (!isActive) return;
        setFailed(true);
      }
    };

    loadImage();

    return () => {
      isActive = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  if (failed) {
    return (
      <div style={{ marginTop: '10px', fontSize: '12px', color: '#B91C1C' }}>
        Unable to load signature image.
      </div>
    );
  }

  if (!imageUrl) {
    return (
      <div style={{ marginTop: '10px', fontSize: '12px', color: '#6B7280' }}>
        Loading signature...
      </div>
    );
  }

  return <img alt={alt} src={imageUrl} style={style} />;
};

export default SignatureImage;